import React from "react";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { SxProps, Theme } from "@mui/material/styles";
import { TextInputProps } from "types";

const LABEL_SX: SxProps<Theme> = { display: "block", fontSize: "0.875rem", fontWeight: 500, mb: "0.25rem", color: "text.secondary" };

const TextInput = ({
  type = "text",
  value,
  onChange,
  placeholder = "",
  disabled = false,
  className,
  name,
  id,
  required = false,
  autoComplete,
  maxLength,
  sx,
  label,
}: TextInputProps) => (
  <>
    {label && (
      <Typography component="label" htmlFor={id} sx={LABEL_SX}>
        {label}
      </Typography>
    )}
    <TextField
      id={id}
      name={name}
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      disabled={disabled}
      required={required}
      autoComplete={autoComplete}
      fullWidth
      variant="outlined"
      className={["login-config-input", className].filter(Boolean).join(" ")}
      slotProps={{
        htmlInput: { maxLength },
      }}
      sx={[
        {
          mb: "1.25rem",
          "& .MuiOutlinedInput-root": {
            height: 56,
            "& fieldset": {
              borderColor: "divider",
            },
            "&:hover fieldset": {
              borderColor: "text.primary",
            },
            "&.Mui-focused fieldset": {
              borderColor: "text.primary",
            },
            "&.Mui-disabled": {
              opacity: 0.6,
            },
          },
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    />
  </>
);

export default TextInput;
